import * as yup from "yup";
import { addKeyToFieldsRecursively } from "@/react/schema/schemaFields";

const schema = yup.object({
  didId: yup.string(),
  address: yup.object({
    addressId: yup.string(),
    freeForm: yup.string(),
  }),
  phoneNumber: yup.string(),
  emergencyDetails: yup.object({
    firstName: yup.string(),
    lastName: yup.string(),
    email: yup.string(),
  }),
});

addKeyToFieldsRecursively(schema);

export default schema;
